import { useSelector } from 'react-redux'
import { ApplicationState } from '@/state/root.models'
import AuthorizedApp from '../authorization-app/index.component'

import UnAuthorizedApp from '../un-authorization-app/index.component'
import { BrowserRouter } from 'react-router-dom'

const AuthInitGuard = () => {
  const { token, loggedUser } = useSelector(
    ({ auth }: ApplicationState) => auth,
  )

  return (
    <BrowserRouter>
      {token && loggedUser ? <AuthorizedApp /> : <UnAuthorizedApp />}
    </BrowserRouter>
  )
}

export default AuthInitGuard
